import React from "react";
import { Navbar } from "@/components/Navbar";
import { useI18n } from "@/context/I18nContext";

function LegalLayout({ title, updated, children }) {
  return (
    <div className="min-h-screen bg-slate-950">
      <Navbar />
      <main className="max-w-3xl mx-auto px-4 sm:px-6 py-14">
        <h1 className="font-heading text-3xl sm:text-4xl font-bold tracking-tight text-white">{title}</h1>
        <p className="mt-2 text-sm text-slate-500">{updated}</p>
        <div className="mt-8 space-y-6 text-slate-300 leading-relaxed text-sm">{children}</div>
      </main>
    </div>
  );
}

const S = ({ h, children }) => (
  <section>
    <h2 className="font-heading text-lg font-semibold text-white mb-2">{h}</h2>
    <p>{children}</p>
  </section>
);

export function Privacy() {
  const { lang } = useI18n();
  const it = lang === "it";
  return (
    <LegalLayout
      title={it ? "Informativa sulla Privacy" : "Privacy Policy"}
      updated={it ? "Ultimo aggiornamento: giugno 2026" : "Last updated: June 2026"}>
      <div data-testid="privacy-page">
        <S h={it ? "Titolare del trattamento" : "Data controller"}>
          {it ? "Rexxpons tratta i dati personali e i dati di bilancio caricati esclusivamente per fornire i servizi di analisi finanziaria e rating richiesti dall'utente."
              : "Rexxpons processes personal data and financial statement data uploaded solely to provide the financial analysis and rating services requested by the user."}
        </S>
        <S h={it ? "Dati raccolti" : "Data collected"}>
          {it ? "Raccogliamo email e credenziali di accesso, i dati di bilancio inseriti o caricati e i dati d'uso necessari al funzionamento del servizio. I dati di bilancio sono utilizzati solo per generare le analisi."
              : "We collect email and login credentials, the financial data entered or uploaded, and usage data needed to operate the service. Financial data is used only to generate analyses."}
        </S>
        <S h={it ? "Conservazione e sicurezza" : "Storage and security"}>
          {it ? "I dati sono conservati in database protetti e non sono ceduti a terzi per finalità di marketing. Puoi richiederne la cancellazione in qualsiasi momento."
              : "Data is stored in secured databases and is not sold to third parties for marketing purposes. You may request deletion at any time."}
        </S>
        <S h={it ? "Diritti dell'utente (GDPR)" : "User rights (GDPR)"}>
          {it ? "Hai diritto di accesso, rettifica, cancellazione e portabilità dei tuoi dati. Per esercitarli scrivi a info@ratingonline.store."
              : "You have the right to access, rectify, delete and port your data. To exercise these rights, write to info@ratingonline.store."}
        </S>
      </div>
    </LegalLayout>
  );
}

export function Terms() {
  const { lang } = useI18n();
  const it = lang === "it";
  return (
    <LegalLayout
      title={it ? "Termini di Servizio" : "Terms of Service"}
      updated={it ? "Ultimo aggiornamento: giugno 2026" : "Last updated: June 2026"}>
      <div data-testid="terms-page">
        <S h={it ? "Oggetto del servizio" : "Service scope"}>
          {it ? "Rexxpons fornisce strumenti automatici di riclassificazione di bilancio, calcolo di indici, rating sintetico e simulazioni. I risultati hanno finalità informativa e di supporto decisionale."
              : "Rexxpons provides automated tools for statement reclassification, ratio calculation, synthetic rating and simulations. Results are for informational and decision-support purposes."}
        </S>
        <S h={it ? "Assenza di consulenza" : "No professional advice"}>
          {it ? "Il rating e i commenti generati non costituiscono consulenza finanziaria, legale o creditizia vincolante. Le decisioni restano responsabilità dell'utente."
              : "The generated rating and commentary do not constitute binding financial, legal or credit advice. Decisions remain the user's responsibility."}
        </S>
        <S h={it ? "Uso corretto e abbonamenti" : "Acceptable use and subscriptions"}>
          {it ? "L'utente si impegna a inserire dati veritieri e a non utilizzare il servizio per scopi illeciti. Alcune funzioni richiedono un abbonamento o crediti a pagamento."
              : "The user agrees to enter truthful data and not to use the service for unlawful purposes. Some features require a paid subscription or credits."}
        </S>
        <S h={it ? "Limitazione di responsabilità" : "Limitation of liability"}>
          {it ? "Rexxpons non è responsabile per eventuali danni derivanti da decisioni basate sulle analisi fornite. Per informazioni: info@ratingonline.store."
              : "Rexxpons is not liable for any damages arising from decisions based on the analyses provided. For information: info@ratingonline.store."}
        </S>
      </div>
    </LegalLayout>
  );
}
